import React from 'react'
import styled from 'styled-components'

import AntProgress from 'antd/lib/progress'
require('antd/lib/progress/style')

const StyledProgress = styled(({ spin, ...rest }) => <AntProgress {...rest} />)`
  ${props => (props.spin ? `animation: spin 2s linear infinite;` : '')};
`

const spinProps = {
  showInfo: false,
  percent: 40,
  type: 'circle'
}

const Progress = props => {
  const modifiedProps = {
    ...props,
    ...(props.spin ? spinProps : {})
  }
  return <StyledProgress {...modifiedProps} />
}

export default Progress
